import React, { useMemo, useState, useCallback }from 'react';
import LineupDataContainer from '../containers/LineupDataContainer';
import MatchupDataContainer from '../containers/MatchupDataContainer';
import Tabs from '@gameday/components/Tabs/Tabs';
import { TabsWrapper } from '../LineupMatchup.style';
import useTracking from '@gameday/utils/hooks/useTracking';

const LineupMatchup = ({
    tabsData
}) => {
  const Tracking = useTracking();
  const [selectedIndex, setSelectedIndex] = useState(0);    
     
    const handleTabChange = useCallback((e) => {
        const text = e?.currentTarget?.innerText || '';
        setSelectedIndex(e?.currentTarget.dataset.index * 1);
       
        const cfg = {
            componentName : ['Preview', text],
            selectedIndex: e?.currentTarget?.dataset?.index * 1,
            text,
            activity: 'Tab Click'
        };
        Tracking.track.track_click(cfg);
    }, [selectedIndex, tabsData]);

    const tabbedView = useMemo(() => {
        const tabId = tabsData?.[selectedIndex]?.id;
        switch (tabId) {
            case 'lineups':
                return <LineupDataContainer />;
            case 'matchups':
                return <MatchupDataContainer />;
        }
    }, [selectedIndex, tabsData]);

    const thisKey = `${selectedIndex}-${tabsData?.length}`;

    return (
        <TabsWrapper>
            <Tabs activeTab={selectedIndex} items={tabsData} handleTabChange={handleTabChange} key={`lm-tab-${thisKey}`}/>
            <div key={`tabbedView-${thisKey}`}>{tabbedView}</div>
        </TabsWrapper>
    );
};
export default LineupMatchup;

